import {useCallback} from 'react';
import type {AssetType} from '~/common/components/MegaNav/MegaNavVariant/types';
import {Link} from '~library/atoms/Link';
import {Picture} from '~library/atoms/Picture';
import {Video} from '~library/atoms/Video';
import {useTracking} from '~library/context/tracking/tracking-context';
import {useIsExtraLargeAndUp} from '~library/hooks/useMatchQuery';
import * as styles from './SubCategoryAssets.module.scss';

type SubCategoryAssetsProps = {
  assets: AssetType[];
};

export const SubCategoryAssets = ({assets}: SubCategoryAssetsProps) => {
  const isExtraLargeAndUp = useIsExtraLargeAndUp();
  const {track} = useTracking();

  const handleAssetClick = useCallback(
    (asset: AssetType) => () => {
      track({
        dataQaId: asset.dataQaId,
        href: asset.href,
        isVideo: asset.isVideo,
        altText: asset.altText,
      });
    },
    [track]
  );

  if (!isExtraLargeAndUp) {
    return null;
  }

  return (
    <div className={styles.assetsContainer}>
      {assets?.length > 0 &&
        assets.map((asset: AssetType) => (
          <Link
            key={`${asset.href}-${asset.dataQaId}`}
            href={asset.href}
            data-qa-id={asset.dataQaId}
            className={styles.assetLink}
            onClick={handleAssetClick(asset)}
          >
            <div className={styles.assetWrapper}>
              {asset.isVideo ? (
                <Video src={asset.srcSet} options={asset.options} />
              ) : (
                <Picture srcSet={asset.srcSet} alt={asset.altText || ''} loading="lazy" />
              )}
            </div>
          </Link>
        ))}
    </div>
  );
};
